class Utils
{
	constructor()
	{
	}

	is_float(value) {
	  return typeof value === "number" && !Number.isInteger(value);
	}

	is_json_str(str)
	{
		try
		{
		  JSON.parse(str);
		  return true;
		}
		catch (e)
		{
		  return false;
		}
	}

	// Does this work for a plain string?
	is_json(item)
	{
		let value = JSON.stringify(item);
		try {
		  value = JSON.parse(value);
		  return true;
		} catch (e) {
		  return false;
		}
	}

	json_clean_numbers(json) {
	  // Loop through each property in the JSON object
	  for (let key in json) {
	    if (typeof json[key] === "string" && !isNaN(json[key])) {
	      // Convert to a float or integer as appropriate
	      json[key] = json[key].includes('.') ? parseFloat(json[key]) : parseInt(json[key], 10);
	    }
	  }
	  return json;
	}
}

const utils = new Utils();
module.exports = utils;

